<template>
  <div class="image-container">
    <transition :name="transition">
      <img v-show="loaded" :src="src" @load="onLoaded" />
    </transition>
  </div>
</template>

<script>
export default {
  name: "QuestionImage",
  props: {
    src: String,
    transition: String,
  },
  data() {
    return {
      loaded: false,
    };
  },
  methods: {
    onLoaded() {
      this.loaded = true;
    },
  },
};
</script>
